__turbopack_context__.v({
  "className": "ibm_plex_mono_b627992a-module__-Oj8qq__className",
});
